import React, { useCallback, useEffect, useMemo } from 'react';
import isNil from 'lodash/isNil';
import { useAppDispatch } from '../../../../../../redux/hooks';
import { useCohortRowContext } from '../../CohortRowContext';
import useAnalysisBuilderInfo from '../../../../../../redux/selectorHooks/useAnalysisBuilderInfo';
import {
  IRowMeta,
  setCohortRowOperatorValues,
} from '../../../../../../redux/slices/oldBuilder';
import { assertCondition, assertNotNil } from '../../../../../../utils/types';
import { FunnelCohortOperatorKey } from '../../../../../../utils/apollo/graphqlSchema';
import FunnelStepMenu from '../../../../../FunnelStepMenu';

const FunnelCohortStepMenu = () => {
  const dispatch = useAppDispatch();
  const { rowMeta, cohortRow, isTimeToConvertRow } = useCohortRowContext();
  const { analysisId, aliasReplacements, operator, operatorValues } = cohortRow;

  const selectedStepIndex = operatorValues?.[0];

  const analysisBuilderInfo = useAnalysisBuilderInfo(analysisId);
  const builderInfo = analysisBuilderInfo?.query;

  const menuRowMeta = useMemo<IRowMeta>(
    () => ({
      ...rowMeta,
      // In case of Funnel, operator value will represent a step, and its only
      // possible value to get so that's why numberIndex is hardcoded
      numberIndex: 0,
    }),
    [rowMeta],
  );

  const handleChangeStep = useCallback(
    (stepIndex: number) => {
      dispatch(
        setCohortRowOperatorValues({
          newValue: stepIndex,
          rowMeta: menuRowMeta,
        }),
      );
    },
    [dispatch, menuRowMeta],
  );

  const filteredSteps = useMemo(() => {
    // Use fall back options if Funnel is not yet selected
    if (!builderInfo) {
      return [];
    }

    assertCondition(builderInfo?.__typename === 'FunnelQuery');
    const steps = builderInfo.steps;

    return steps.filter((step) => {
      assertNotNil(step.seq);
      // if selected operator starts with 'DROP_OFF', we only display seq > 0
      if (
        operator === FunnelCohortOperatorKey.DropOffSince ||
        operator === FunnelCohortOperatorKey.DropOffBefore
      ) {
        return step.seq > 0;
      }

      return true;
    });
  }, [builderInfo, operator]);

  // Set default value
  useEffect(() => {
    if (isNil(selectedStepIndex)) {
      handleChangeStep(0);
    }
  }, [handleChangeStep, selectedStepIndex]);
  return (
    <FunnelStepMenu
      steps={filteredSteps}
      selectedStep={
        !isNil(selectedStepIndex) ? selectedStepIndex.toString() : null
      }
      onChange={(value) => handleChangeStep(Number(value))}
      aliasReplacements={aliasReplacements}
      placeholder={'1. Step'}
      isTimeToConvertCohortRow={isTimeToConvertRow}
    />
  );
};

export default FunnelCohortStepMenu;
